import React from "react";

function ActiveFinancedDetailsTab({
  unitsHeld,
  pricePerUnit,
  amountFinanced,
  dateFinanced,
  developerName,
  formatAmount,
}) {
  return (
    <div className="bg-white rounded-[16px] border border-[#F1F5F9] p-4.5 shadow-2xs">
      <h3 className="text-[#1E222B] text-[13px] font-[800] mb-4">
        Your Financing
      </h3>

      <div className="space-y-3.5">
        <div className="flex items-center justify-between">
          <span className="text-[#808285] text-[12px] font-[500]">
            Units Held
          </span>
          <span className="text-[#1E222B] text-[12.5px] font-[700]">
            {unitsHeld}
          </span>
        </div>

        <div className="flex items-center justify-between">
          <span className="text-[#808285] text-[12px] font-[500]">
            Price / unit at purchase
          </span>
          <span className="text-[#1E222B] text-[12.5px] font-[700]">
            ₦{formatAmount(pricePerUnit)}
          </span>
        </div>

        <div className="flex items-center justify-between">
          <span className="text-[#808285] text-[12px] font-[500]">
            Total amount financed
          </span>
          <span className="text-[#1E222B] text-[12.5px] font-[700]">
            ₦{formatAmount(amountFinanced)}
          </span>
        </div>

        <div className="flex items-center justify-between">
          <span className="text-[#808285] text-[12px] font-[500]">
            Date financed
          </span>
          <span className="text-[#1E222B] text-[12.5px] font-[700]">
            {dateFinanced}
          </span>
        </div>

        <div className="flex items-center justify-between">
          <span className="text-[#808285] text-[12px] font-[500]">
            Developer
          </span>
          <span className="text-[#1E222B] text-[12.5px] font-[700]">
            {developerName}
          </span>
        </div>
      </div>
    </div>
  );
}

export default ActiveFinancedDetailsTab;
